<template>
  <div>
    <p class="is-pulled-right">π</p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
